import VueRouter from "vue-router";
import VueBodyClass from "vue-body-class";
import store from "./store";
import request from '@/api/axios';

import CategoryFeed from "@/components/newRedesign/pages/CategoryFeed";
import MainPageRedesignNew from "@/components/newRedesign/pages/MainPageNewCopy";
import Login from "@/components/redesign/Login";
import LoginNewCopy from "@/components/newRedesign/pages/Login/LoginNewCopy";
import LoginInvest from "@/components/newRedesign/pages/Login/LoginInvest";
import Profile from "@/components/newRedesign/pages/Profile/Profile";
import PromoPage from "@/components/pages/Promo";
import Offer from "@/components/newRedesign/Offer";
import Privacy from "@/components/newRedesign/pages/Privacy";
import ArticleNewCopy from "@/components/newRedesign/pages/Article";
import Contacts from "@/components/newRedesign/pages/Contacts";
import AboutNew from "@/components/newRedesign/pages/About";
import ConsultationsPage from "@/components/newRedesign/pages/Consultations";
import InvestmentsPage from "@/components/newRedesign/pages/Investments";
import InvestmentsLanding from "@/components/newRedesign/pages/InvestmentsLanding";

const routes = [
  {
    path: "/",
    component: MainPageRedesignNew,
    name: "___redesign",
    meta: {
      showMonthOffers: true,
      layout: "index-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/journal",
    component: MainPageRedesignNew,
    name: "___redesign",
    meta: {
      showMonthOffers: true,
      layout: "index-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/consultations",
    component: ConsultationsPage,
    name: "___redesign",
    meta: {
      layout: "index-redesign",
      bodyClass: "__redesign",
      name: "consultations",
    },
  },
  {
    path: "/landing-invest",
    component: InvestmentsLanding,
    name: "___redesign",
    meta: {
      layout: "index-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/investments",
    component: InvestmentsPage,
    name: "___redesign",
    meta: {
      layout: "index-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/category/:code",
    component: CategoryFeed,
    name: "___redesign",
    meta: {
      showMonthOffers: true,
      layout: "index-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/article/:code",
    component: ArticleNewCopy,
    name: "___redesign",
    meta: {
      layout: "index-redesign",
      bodyClass: "__redesign",
      name: "article",
    },
  },
  {
    path: "/feedback",
    component: Contacts,
    name: "___redesign",
    meta: {
      layout: "default-redesign",
      bodyClass: "__redesign",
      name: "contacts",
    },
  },
  {
    path: "/about",
    component: AboutNew,
    name: "___redesign",
    meta: {
      layout: "default-redesign",
      bodyClass: "__redesign",
      name: "about",
    },
  },
  {
    path: "/login",
    component: LoginNewCopy,
    name: "login",
    meta: {
      guest: true,
      bodyClass: "__redesign login-page promo-page",
      layout: "promo",
    },
  },
  {
    path: "/login-invest",
    component: LoginInvest,
    name: "login",
    meta: {
      guest: true,
      bodyClass: "__redesign login-page promo-page",
      layout: "promo",
    },
  },
  {
    path: "/mail",
    component: Login,
    name: "login",
    meta: {
      guest: true,
      bodyClass: "__redesign login-page promo-page",
      layout: "promo",
      mail: true,
    },
  },
  {
    path: "/profile",
    component: Profile,
    name: "___redesign",
    meta: {
      requiresAuth: true,
      bodyClass: "__redesign",
      layout: "index-redesign",
    },
  },
  {
    path: "/promo",
    component: PromoPage,
    name: "promo",
    meta: {
      bodyClass: "promo-page",
      layout: "index",
    },
  },
  {
    path: "/promo-invest",
    component: PromoPage,
    name: "promo-invest",
    meta: {
      bodyClass: "promo-page",
      layout: "index",
    },
  },
  {
    path: "/offer",
    component: Offer,
    name: "___redesign",
    meta: {
      layout: "default-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "/privacy",
    component: Privacy,
    name: "___redesign",
    meta: {
      layout: "default-redesign",
      bodyClass: "__redesign",
    },
  },
  {
    path: "*",
    redirect: "/",
  },
];

// Функция для авторизации по токену
const tryTokenAuth = async (token, login) => {
  try {
    const response = await request({
      action: 'login_raw',
      options: {
        phone: login,
        token
      }
    });

    if (response.data.status === true) {
      store.commit('login', response.data.user);
      if (response.data.user_inv) {
        store.commit('loginInv', response.data.user_inv);
      }
      return true;
    }
    return false;
  } catch (error) {
    console.error('Token auth error:', error);
    return false;
  }
};

const router = new VueRouter({
  mode: "history",
  routes,
});

const vueBodyClass = new VueBodyClass(routes);
router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0);
  vueBodyClass.guard(to, next);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.user === null) {

      // Проверяем наличие GET-параметров token и login
      const token = to.query.token;
      const login = to.query.login;

      if (token && login) {
        // Пытаемся авторизовать пользователя по токену
        const authSuccess = await tryTokenAuth(token, login);
        console.log('authSuccess', authSuccess);

        // Создаем новый объект query без token и login
        const newQuery = { ...to.query };
        delete newQuery.token;
        delete newQuery.login;

        if (authSuccess) {
          // При успешной авторизации остаемся на текущей странице, но без параметров
          next({
            path: to.path,
            query: newQuery,
            hash: to.hash
          });
        } else {
          // При неудачной авторизации переходим на login
          next({ path: "/login" });
        }
      } else {
        next({ path: "/login" });
      }

    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (store.state.user === null) {
      next();
    } else if (store.state.user.payment.type !== 1 && store.state.user.payment.type !== 2) {
      next({ path: "/promo" });
    } else {
      next({ path: "/" });
    }
  } else {
    next();
  }
});

export default router;
